/* KingZoo Redesign Test: staging-only accessibility and UX layer */
(function () {
  'use strict';

  var initQueued = false;

  function language() {
    return (document.documentElement.lang || 'tr').toLowerCase().indexOf('en') === 0 ? 'en' : 'tr';
  }

  function rootPath() {
    if (window.Shopify && Shopify.routes && Shopify.routes.root) return Shopify.routes.root;
    return language() === 'en' ? '/en/' : '/';
  }

  function rooted(path) {
    var root = rootPath();
    if (root.charAt(root.length - 1) !== '/') root += '/';
    return root + String(path || '').replace(/^\//, '');
  }

  function injectSprint6Styles() {
    if (document.getElementById('kz-redesign-sprint6')) return;

    var style = document.createElement('style');
    style.id = 'kz-redesign-sprint6';
    style.textContent = `
      /* Sprint 6: header, navigation and cart drawer */
      .header__buttons {
        gap: 0.2rem;
      }

      .header__buttons > a,
      .header__buttons > button,
      .header__buttons .btn {
        border-radius: 999px;
        transition: background-color 160ms ease, opacity 160ms ease, transform 160ms ease;
      }

      @media (hover: hover) {
        .header__buttons > a:hover,
        .header__buttons > button:hover,
        .header__buttons .btn:hover {
          background: rgba(var(--color-foreground), 0.06);
        }
      }

      .header__navigation a {
        text-underline-offset: 0.35em;
      }

      #MenuDrawer .drawer__inner {
        width: min(92vw, 430px);
      }

      #MenuDrawer .drawer__header {
        min-height: 68px;
        border-bottom: 1px solid rgba(var(--color-foreground), 0.1);
      }

      #MenuDrawer .drawer__navigation > ul > li,
      #MenuDrawer details[is="menu-drawer-details"] {
        border-bottom: 1px solid rgba(var(--color-foreground), 0.08);
      }

      #MenuDrawer .drawer__navigation a,
      #MenuDrawer details[is="menu-drawer-details"] > summary {
        min-height: 52px;
        display: flex;
        align-items: center;
      }

      #MenuDrawer .drawer__footer {
        border-top: 1px solid rgba(var(--color-foreground), 0.1);
      }

      #CartDrawer .drawer__inner {
        width: min(96vw, 520px);
      }

      #CartDrawer .drawer__header {
        min-height: 68px;
        padding-inline: 1.5rem 4rem;
        border-bottom: 1px solid rgba(var(--color-foreground), 0.1);
      }

      #CartDrawer .cart-item {
        padding-block: 1rem;
        border-bottom: 1px solid rgba(var(--color-foreground), 0.08);
      }

      #CartDrawer .cart-item__name,
      #CartDrawer .cart-item__title {
        line-height: 1.3;
        text-wrap: balance;
      }

      #CartDrawer cart-remove-button button,
      #CartDrawer cart-remove-button a,
      #CartDrawer quantity-input button {
        min-width: 44px;
        min-height: 44px;
      }

      #CartDrawer quantity-input,
      #CartDrawer .quantity {
        min-height: 44px;
      }

      #CartDrawer .drawer__footer,
      #CartDrawer .cart-drawer__footer {
        border-top: 1px solid rgba(var(--color-foreground), 0.1);
        background: rgb(var(--color-background));
        box-shadow: 0 -10px 30px rgba(0, 0, 0, 0.04);
      }

      #CartDrawer [name="checkout"],
      #CartDrawer button[type="submit"][name="checkout"] {
        width: 100%;
        min-height: 56px;
        font-weight: 650;
      }

      #CartDrawer .kz-cart-continue {
        width: 100%;
        min-height: 48px;
        margin-top: 0.65rem;
      }

      #CartDrawer .kz-cart-continue + * {
        margin-top: 0.65rem;
      }

      .announcement-bar,
      .announcement-bar__message {
        line-height: 1.35;
      }

      @media (max-width: 767px) {
        #MenuDrawer .drawer__inner,
        #CartDrawer .drawer__inner {
          width: 100vw;
          max-width: 100vw;
        }

        #CartDrawer .drawer__header {
          padding-inline-start: 1rem;
        }

        #CartDrawer .cart-item {
          padding-block: 0.85rem;
        }
      }
    `;
    document.head.appendChild(style);
  }

  function fixLabels(scope) {
    scope = scope || document;
    var lang = language();
    var menuLabel = lang === 'en' ? 'Menu' : 'Menü';
    var cartLabel = lang === 'en' ? 'Cart' : 'Sepet';
    var closeLabel = lang === 'en' ? 'Close' : 'Kapat';
    var searchLabel = lang === 'en' ? 'Search' : 'Ara';

    scope.querySelectorAll('.menu-drawer-button').forEach(function (button) {
      button.setAttribute('aria-label', menuLabel);
    });

    scope.querySelectorAll('.cart-drawer-button, [aria-controls="CartDrawer"]').forEach(function (link) {
      link.setAttribute('aria-label', cartLabel);
    });

    scope.querySelectorAll('[aria-controls="SearchDrawer"]').forEach(function (button) {
      if (!button.getAttribute('aria-label')) button.setAttribute('aria-label', searchLabel);
    });

    scope.querySelectorAll('.drawer__close-btn, .drawer__close').forEach(function (button) {
      button.setAttribute('aria-label', closeLabel);
      if (button.tagName === 'BUTTON' && !button.getAttribute('type')) button.setAttribute('type', 'button');
    });
  }

  function syncDetails(scope) {
    scope = scope || document;
    scope.querySelectorAll('details.accordion-details').forEach(function (details) {
      details.setAttribute('aria-expanded', details.open ? 'true' : 'false');
    });
  }

  function syncMenuDetails(scope) {
    scope = scope || document;
    scope.querySelectorAll('#MenuDrawer details[is="menu-drawer-details"]').forEach(function (details) {
      var expanded = details.open ? 'true' : 'false';
      var summary = details.querySelector(':scope > summary');
      details.setAttribute('aria-expanded', expanded);
      if (summary) summary.setAttribute('aria-expanded', expanded);
    });
  }

  function improveLiveRegions(scope) {
    scope = scope || document;
    scope.querySelectorAll('#ProductCount, #CartDrawer cart-count, #CartDrawer .cart-count, #CartDrawer [data-cart-count]').forEach(function (node) {
      node.setAttribute('aria-live', 'polite');
      node.setAttribute('aria-atomic', 'true');
    });
  }

  function fixProductImageAlts(scope) {
    scope = scope || document;
    scope.querySelectorAll('.product-card').forEach(function (card) {
      var titleLink = card.querySelector('.product-card__title a');
      var title = titleLink ? titleLink.textContent.trim() : '';
      if (!title) return;

      card.querySelectorAll('img').forEach(function (image) {
        if (!image.hasAttribute('alt') || !image.getAttribute('alt').trim()) {
          image.setAttribute('alt', title);
        }
      });
    });
  }

  function markCurrentNavigation(scope) {
    scope = scope || document;
    var currentPath = window.location.pathname.replace(/\/$/, '') || '/';
    scope.querySelectorAll('.header__navigation a[href], #MenuDrawer a[href]').forEach(function (link) {
      try {
        var url = new URL(link.href, window.location.origin);
        var path = url.pathname.replace(/\/$/, '') || '/';
        if (url.origin === window.location.origin && path === currentPath) {
          link.setAttribute('aria-current', 'page');
        }
      } catch (e) {}
    });
  }

  function improveFacetDialog(scope) {
    scope = scope || document;
    var drawer = scope.querySelector('#FacetDrawer') || document.querySelector('#FacetDrawer');
    if (!drawer) return;

    drawer.setAttribute('role', 'dialog');
    drawer.setAttribute('aria-modal', 'true');
    var heading = drawer.querySelector('.drawer__heading');
    if (heading) {
      if (!heading.id) heading.id = 'FacetDrawerTitle';
      drawer.setAttribute('aria-labelledby', heading.id);
    }
  }

  function improveDrawerSemantics(scope) {
    scope = scope || document;
    var configs = [
      { id: 'MenuDrawer', headingId: 'MenuDrawerTitle' },
      { id: 'SearchDrawer', headingId: 'SearchDrawerTitle' },
      { id: 'CartDrawer', headingId: 'CartDrawerTitle' }
    ];

    configs.forEach(function (config) {
      var drawer = scope.querySelector('#' + config.id) || document.getElementById(config.id);
      if (!drawer) return;

      drawer.setAttribute('role', 'dialog');
      drawer.setAttribute('aria-modal', 'true');

      var heading = drawer.querySelector('.drawer__heading, h2, h3');
      if (heading) {
        if (!heading.id) heading.id = config.headingId;
        drawer.setAttribute('aria-labelledby', heading.id);
      }
    });

    syncDrawerTriggers();
  }

  function syncDrawerTriggers() {
    ['MenuDrawer', 'SearchDrawer', 'CartDrawer'].forEach(function (id) {
      var drawer = document.getElementById(id);
      if (!drawer) return;
      var expanded = drawer.hasAttribute('hidden') ? 'false' : 'true';
      document.querySelectorAll('[aria-controls="' + id + '"]').forEach(function (trigger) {
        if (trigger.closest && trigger.closest('#' + id) && (trigger.classList.contains('drawer__close') || trigger.classList.contains('drawer__close-btn'))) {
          return;
        }
        trigger.setAttribute('aria-expanded', expanded);
      });
    });
  }

  function syncMobileProductCount() {
    var source = document.querySelector('#ProductCount');
    var toolbar = document.querySelector('.collection__toolbar');
    if (!source || !toolbar) return;

    var text = source.textContent.replace(/\s+/g, ' ').trim();
    if (!text) return;

    var mobileCount = toolbar.querySelector('.kz-mobile-product-count');
    if (!mobileCount) {
      mobileCount = document.createElement('span');
      mobileCount.className = 'kz-mobile-product-count';
      mobileCount.setAttribute('role', 'status');
      mobileCount.setAttribute('aria-live', 'polite');
      mobileCount.setAttribute('aria-atomic', 'true');
      toolbar.insertBefore(mobileCount, toolbar.firstChild);
    }
    mobileCount.textContent = text;
  }

  function syncLayoutSwitcher(scope) {
    scope = scope || document;
    scope.querySelectorAll('.layout-switcher button, layout-switcher button').forEach(function (button) {
      button.setAttribute('aria-pressed', button.classList.contains('btn--active') ? 'true' : 'false');
    });
  }

  function enhanceEmptySearch(scope) {
    scope = scope || document;
    var page = scope.querySelector('.template-search--empty');
    if (!page || page.querySelector('.kz-search-recovery')) return;

    var emptyMessage = page.querySelector('.template-search__header .text-center.grid.gap-1');
    if (!emptyMessage) return;

    var lang = language();
    var box = document.createElement('div');
    box.className = 'kz-search-recovery';
    box.setAttribute('aria-label', lang === 'en' ? 'Search alternatives' : 'Arama alternatifleri');

    var text = document.createElement('p');
    text.className = 'kz-search-recovery__text';
    text.textContent = lang === 'en'
      ? 'Try a different keyword or continue by browsing the full collection.'
      : 'Farklı bir kelime deneyebilir veya tüm ürünlere göz atarak devam edebilirsin.';

    var actions = document.createElement('div');
    actions.className = 'kz-search-recovery__actions';

    var allProducts = document.createElement('a');
    allProducts.className = 'btn btn--primary';
    allProducts.href = rooted('collections/all');
    allProducts.textContent = lang === 'en' ? 'View all products' : 'Tüm ürünleri gör';

    var home = document.createElement('a');
    home.className = 'btn btn--secondary';
    home.href = rootPath();
    home.textContent = lang === 'en' ? 'Back to home' : 'Ana sayfaya dön';

    actions.appendChild(allProducts);
    actions.appendChild(home);
    box.appendChild(text);
    box.appendChild(actions);
    emptyMessage.insertAdjacentElement('afterend', box);
  }

  function enhanceCartDrawer(scope) {
    scope = scope || document;
    var drawer = scope.querySelector('#CartDrawer') || document.getElementById('CartDrawer');
    if (!drawer) return;

    var hasItems = !!drawer.querySelector('cart-items .cart-item, cart-drawer-items .cart-item, .cart-drawer__items .cart-item, [data-cart-item]');
    var existing = drawer.querySelector('.kz-cart-continue');

    if (!hasItems) {
      if (existing) existing.remove();
      return;
    }

    if (existing) return;

    var checkout = drawer.querySelector('[name="checkout"]');
    var footer = drawer.querySelector('.drawer__footer, .cart-drawer__footer');
    var anchor = checkout || footer;
    if (!anchor) return;

    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'btn btn--secondary kz-cart-continue';
    button.setAttribute('aria-controls', 'CartDrawer');
    button.textContent = language() === 'en' ? 'Continue shopping' : 'Alışverişe devam et';

    if (checkout && checkout.parentNode) {
      checkout.insertAdjacentElement('afterend', button);
    } else if (footer) {
      footer.insertBefore(button, footer.firstChild);
    }
  }

  function init(scope) {
    injectSprint6Styles();
    fixLabels(scope);
    syncDetails(scope);
    syncMenuDetails(scope);
    improveLiveRegions(scope);
    fixProductImageAlts(scope);
    markCurrentNavigation(scope);
    improveFacetDialog(scope);
    improveDrawerSemantics(scope);
    enhanceCartDrawer(scope);
    syncMobileProductCount();
    syncLayoutSwitcher(scope);
    enhanceEmptySearch(scope);
  }

  function queueInit() {
    if (initQueued) return;
    initQueued = true;
    window.requestAnimationFrame(function () {
      initQueued = false;
      init(document);
    });
  }

  document.addEventListener('toggle', function (event) {
    var target = event.target;
    if (!target || !target.matches) return;

    if (target.matches('details.accordion-details')) {
      target.setAttribute('aria-expanded', target.open ? 'true' : 'false');
    }

    if (target.matches('#MenuDrawer details[is="menu-drawer-details"]')) {
      var summary = target.querySelector(':scope > summary');
      var expanded = target.open ? 'true' : 'false';
      target.setAttribute('aria-expanded', expanded);
      if (summary) summary.setAttribute('aria-expanded', expanded);
    }
  }, true);

  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('.layout-switcher button, layout-switcher button');
    if (button) window.requestAnimationFrame(function () { syncLayoutSwitcher(document); });

    var continueButton = event.target.closest && event.target.closest('.kz-cart-continue');
    if (continueButton) {
      var drawer = document.getElementById('CartDrawer');
      var close = drawer && drawer.querySelector('.drawer__close-btn, .drawer__close');
      if (close) close.click();
    }

    var drawerTrigger = event.target.closest && event.target.closest('[aria-controls="MenuDrawer"], [aria-controls="SearchDrawer"], [aria-controls="CartDrawer"]');
    if (drawerTrigger) window.requestAnimationFrame(syncDrawerTriggers);
  });

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  var observer = new MutationObserver(function (mutations) {
    var relevant = mutations.some(function (mutation) {
      if (mutation.type === 'attributes') {
        var target = mutation.target;
        if (!target || target.nodeType !== 1) return false;
        return target.matches && (
          target.matches('#MenuDrawer, #SearchDrawer, #CartDrawer, #MenuDrawer details[is="menu-drawer-details"]')
        );
      }

      if (mutation.type !== 'childList' || !mutation.addedNodes.length) return false;
      return Array.prototype.some.call(mutation.addedNodes, function (node) {
        if (node.nodeType !== 1) return false;
        return node.matches && (
          node.matches('#ProductGridContainer, #ProductCount, .collection__toolbar, .product-card, #FacetDrawer, #MenuDrawer, #SearchDrawer, #CartDrawer, cart-items, cart-drawer-items') ||
          node.querySelector && node.querySelector('#ProductGridContainer, #ProductCount, .collection__toolbar, .product-card, #FacetDrawer, #MenuDrawer, #SearchDrawer, #CartDrawer, cart-items, cart-drawer-items')
        );
      });
    });
    if (relevant) queueInit();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
      observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['hidden', 'open'] });
    });
  } else {
    init(document);
    observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['hidden', 'open'] });
  }
})();
